module.exports = __webpack_public_path__ + "static/media/ship-bg-mobile-princess.49446883.jpg";